import { Link } from 'ui/icons/other/Link';
import { isNull } from 'utils/tsHelpers';
import { useModalContext } from 'utils/contexts/modal';
import { BaseToolbarButton } from './BaseToolbarButton';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { useSelectedHyperlink } from '../hooks/useSelectedHyperlink';
import { HYPERLINK_MODAL_ID } from '../constants';

export const ToggleLinkButton = () => {
  const { t } = useTranslation();
  const selectedHyperlink = useSelectedHyperlink();
  const { showModal } = useModalContext();

  return (
    <BaseToolbarButton
      isSelected={!isNull(selectedHyperlink)}
      onClick={() => showModal(HYPERLINK_MODAL_ID)}
      tooltip={t('contentPicker.textEditor.link')}
      data-test="link-button"
    >
      <Link isColorInherited />
    </BaseToolbarButton>
  );
};
